import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  containingObjects: {
    display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
    //paddingTop: '0rem',
    paddingBottom: '2rem',
    paddingRight: '1.5rem',
  },
  //BatchInfo
  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  fontPadding2: {
    textAlign: 'initial',
  },
  fontPadding: {
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
    overflow: 'auto',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  //Consumption
  export: {
    backgroundColor: 'transparent',
    color: 'black',
    border: '1px solid #000000de',
    textTransform: 'none',
    borderRadius: '2rem',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid black',
    },
  },
  //otherDocuments
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
  },

  closeText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  document: {
    display: 'flex',
    alignItems: 'center',
  },
  filesFont: {
    fontWeight: 500,
    paddingTop: '0.5rem',
    paddingBottom: '1rem',
    fontSize: '1rem',
  },
  fileIcon: {
    cursor: 'pointer',
    textAlign: 'end',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  input: {
    display: 'none',
  },
  child: {
    paddingTop: '1rem',
  },
  textDiv: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: '0.5rem',
    cursor: 'pointer',
  },
  //FG - Batch,Shipping,QC styles
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  closeIconSty: {
    fontSize: '1rem',
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'flex-end',
    '&:hover': {
      color: 'red',
    },
  },
  // Demo Requirement changes for Wockhardt + CQA flow.
  shipmentTextBox: {
    '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl': {
      height: '40px'
    }
  },

  viewASNBtn: {
    borderRadius: "50px", // Rounded corners for pill shape
    border: "1px solid #000", // Border with black color
    padding: "5px 15px", // Padding for buttons
    fontWeight: 500,
    // width: "100%",
    color: "#000", // Text color black
    backgroundColor: "#fff", // Background white
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#f4f4f4", // Slightly darker background on hover
    },
  },
}));
